import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";

const VARDIYA = ["00:00 - 08:00", "08:00 - 16:00", "16:00 - 24:00"];

export default function OnerilenBiskuvi() {
  const columns = [
    { key: "tarih", label: "Yükleme Tarihi" },
    { key: "yuklenen_saat", label: "Yükleme Saati", mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "aciklama", label: "Açıklama" },
    { key: "yuklenen_adet", label: "Yüklenen Adet", num: true },
    { key: "vagon_no", label: "Vagon No" },
    { key: "yukleme_personel", label: "Personel" },
    {
      key: "onerilen", label: "Önerilen (Tarih & Saat, +72 saat)",
      value: (r) => r.onerilen,
      render: (r) => r.onerilen
        ? <span className="font-bold text-green-700 whitespace-nowrap">{r.onerilen}</span>
        : <span className="text-zinc-300">—</span>,
    },
  ];
  const fields = [
    { key: "tarih", label: "Tarih", type: "date", required: true },
    { key: "vardiya", label: "Vardiya", type: "select", options: VARDIYA, required: true },
    { key: "yuklenen_saat", label: "Yüklenen Saat", type: "time", required: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", type: "kalipkodu", required: true, span: 2, fills: { aciklama: "aciklama" } },
    { key: "aciklama", label: "Açıklama (otomatik)", type: "text", readOnly: true, span: 2 },
    { key: "yuklenen_adet", label: "Yüklenen Adet", type: "number", required: true },
    { key: "vagon_no", label: "Vagon No", type: "text" },
    { key: "yukleme_personel", label: "Yükleme Yapan Personel", type: "text", span: 2 },
    { key: "notu", label: "Not", type: "text", span: 2 },
  ];
  return (
    <>
      <PageHeader title="Önerilen Bisküvi" subtitle="Bisküvi Fırını Yükleme verisinden otomatik: yükleme saati + 72 saat (Türkiye saati)" />
      <CrudTable endpoint="/entity/kiln" listEndpoint="/planlama/onerilen-biskuvi" columns={columns} fields={fields}
        titleSingular="Fırın Yükleme" dateField="tarih" vardiyaFilter exportKind="kiln" printTitle="Önerilen Bisküvi" disableDelete />
    </>
  );
}
